import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'prizm-release-policy',
  templateUrl: './release-policy.component.html',
  styleUrls: ['./release-policy.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReleasePolicyComponent {}
